import {api} from "@/api/client";
import {Form} from "@/api/types/Form";
import qs from 'qs';

type ListParams = {
    limit?: number,
    skip?: number,
    search?: string,
    tenantIds?: string[]
};

export type FormsData = {
    limit: number,
    skip: number,
    total: number,
    data: Form[]
}


export const buildFormsApi = (client = api) => ({
    async create(form: Partial<Form>) {
        const result = await client.post<Form>('api/forms', form)
        return result.data;
    },

    async fetch(id: number | string) {
        const result = await client.get<Form>(`api/forms/${id}`)
        return result.data;
    },

    async fetchByUid(id: number | string) {
        const result = await client.get<Form>(`api/forms/uid/${id}`)
        return result.data;
    },

    async list(limit?: number, skip?: number, search?: string, tenantIds?: string[]) {
        const params: ListParams = {limit: limit, skip: skip, search: search, tenantIds: tenantIds}
        const result = await client.get<FormsData>('api/forms', {
            params: params,
            paramsSerializer: params => {
                // return qs.stringify(params).replaceAll(/%5B.*%5D/g, '')
                return qs.stringify(params)
            }
        })
        return result.data;
    },

    async patch(id: number, form: Partial<Form>) {
        const result = await client.patch<Form>(`api/forms/${id}`, form)
        return result.data;
    },

    async remove(id: number) {
        const result = await client.delete<Form>(`api/forms/${id}`)
        return result.data;
    }

});

export const {
    create,
    fetch,
    fetchByUid,
    list,
    patch,
    remove
} = buildFormsApi();